import { Box, Button, Divider, Grid, Card, CardContent, List, ListItem, ListItemText } from "@mui/material";
import Typography from "@mui/material/Typography";
import { useTranslation } from 'react-i18next';
import { motion } from "framer-motion"
import image1 from "../../../../public/main/Rastcom - forBusiness.png"
import image2 from "../../../../public/main/forBusiness2.png"

function ForBusiness() {
    const { t, i18n } = useTranslation();
    const text = t("forBusiness.subTitle").split("");

    return (
        <>
            <Grid container pt={5}
                sx={{
                    display: 'flex',
                    msFlexDirection: 'row',
                    justifyContent: 'center',
                    backgroundColor: "#F9FAFB",
                    alignItems: "center",
                    flexDirection: { xs: 'column', md: "row" },
                    marginBottom: 0,
                    padding: { md: '0px 20px' }
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        textAlign: 'center',
                    }}
                >
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6 }}
                        viewport={{ once: true }}
                    >
                        <Divider
                            sx={{
                                borderBottomColor: '#FF7600',
                                borderBottomWidth: '2px',
                                borderBottomStyle: 'solid'
                            }}
                            role="presentation"
                        >
                            <Typography
                                sx={{
                                    fontSize: 26,
                                    fontWeight: 600,
                                    fontFamily: "Arial, sans-serif",
                                    padding: "20px",
                                    color: "#32325d",
                                }}
                            >
                                {t("forBusiness.title")}
                            </Typography>
                        </Divider>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        whileInView={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.6, delay: 0.2 }}
                        viewport={{ once: true }}
                    >
                        <List>
                            <ListItem>
                                <ListItemText
                                    secondaryTypographyProps={{
                                        textAlign: "center",
                                        fontSize: "18px",
                                        fontWeight: "bold",
                                        color: "#800080",
                                    }}
                                    secondary={t("forBusiness.secList1-2")}
                                />
                            </ListItem>
                        </List>
                    </motion.div>

                    <motion.div
                        initial={{ opacity: 0, scale: 0.8 }}
                        whileInView={{ opacity: 1, scale: 1 }}
                        transition={{ duration: 0.4, delay: 0.4 }}
                        viewport={{ once: true }}
                    >
                        <Button
                            variant="contained"
                            href={`${i18n.language}/contact-us`}
                            sx={{ mt: 2, fontFamily: "Arial, sans-serif" }}
                        >
                            {t("forBusiness.requestDemo")}
                        </Button>
                    </motion.div>

                </Box>

                <Grid container
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        backgroundColor: "#F9FAFB",
                        alignItems: "center",
                        flexDirection: { xs: 'column-reverse', md: "row" },
                        marginBottom: 0,
                    }}
                >
                    <Grid item md={5} sm={11} xs={11} m={2}>
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            viewport={{ once: true }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 24,
                                    fontWeight: 600,
                                    marginTop: "20px",
                                    padding: "10px",
                                    color: "#32325d",
                                    maxWidth: "100%",
                                    wordWrap: "break-word",
                                    textAlign: "center",
                                }}
                            >
                                {t("forBusiness.subTitle")}
                            </Typography>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.2 }}
                            viewport={{ once: true }}
                        >
                            <List sx={{ width: "100%" }}>
                                <ListItem>
                                    <ListItemText
                                        secondaryTypographyProps={{
                                            textAlign: "center",
                                            fontSize: "20px",
                                            fontWeight: "bold",
                                            color: "#800080",
                                        }}
                                        secondary={t("forBusiness.secList1")}
                                    />
                                </ListItem>
                            </List>
                        </motion.div>
                        <motion.div
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1, transition: { staggerChildren: 0.2 } }} // Trigger when visible
                            viewport={{ once: true, amount: 0.2 }} // Only trigger once when 20% is in view
                        >
                            <List sx={{ width: "100%", padding: "10px" }}>
                                {["uList1", "uList2", "uList3"].map((key, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0, transition: { duration: 0.4 } }}
                                        viewport={{ once: true }} // Ensures it animates only once
                                        whileHover={{ scale: 1.05 }}
                                    >
                                        <ListItem sx={{ borderLeft: "4px solid #4a90e2", mb: 1 }}>
                                            <ListItemText
                                                primaryTypographyProps={{
                                                    fontSize: "16px",
                                                    fontWeight: "bold",
                                                    color: "#32325d",
                                                }}
                                                primary={t(`forBusiness.${key}`)}
                                            />
                                        </ListItem>
                                    </motion.div>
                                ))}
                            </List>
                        </motion.div>
                        <List sx={{ width: '100%' }}>
                            <ListItem >
                                <ListItemText secondaryTypographyProps={{ fontSize: '14px', color: '#32325d', }} secondary={t('forBusiness.secList2')} />
                            </ListItem>
                            <ListItem >
                                <ListItemText secondaryTypographyProps={{ fontSize: '14px', color: '#32325d', }} secondary={t('forBusiness.secList3')} />
                            </ListItem>
                        </List>
                    </Grid>

                    <Grid item xs={11} md={5} lg={5}
                        sx={{
                            width: '80%',
                            height: 'auto',
                            alignItems: 'center',
                            padding: '10px 0 20px 0',
                            borderRadius: '10px',
                            margin: 'auto'
                        }}
                    >
                        <motion.div
                            initial={{
                                scale: .7
                            }}
                            whileInView={{
                                scale: .9
                            }}
                            transition={{
                                duration: .5
                            }}
                            viewport={{ once: true }}
                        >
                            <img
                                src={image1}
                                style={{
                                    marginTop: "20px",
                                    maxWidth: "100%",
                                    minHeight: "auto"
                                }}
                            />
                        </motion.div>
                    </Grid>
                </Grid>

                <Grid
                    container
                    spacing={3}
                    mt={3}
                    md={11}
                    sx={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: "center",
                        flexDirection: { xs: 'column', md: 'row' }, // Change direction based on screen size
                        backgroundColor: "#F9FAFB",
                        marginBottom: 0,
                    }}
                >
                    {/* Image on the left for md and up */}
                    <Grid item xs={11} md={4} lg={4}
                        sx={{
                            width: { xs: '80%', md: '100%' },
                            height: 'auto',
                            alignItems: 'center',
                            padding: '10px 0 20px 0',
                            borderRadius: '10px',
                            margin: 'auto',
                            textAlign: { xs: 'center', md: 'left' }, // Center on mobile, left-align on larger screens
                        }}
                    >
                        <motion.div
                            initial={{ scale: 0.7 }}
                            whileInView={{ scale: 0.9 }}
                            transition={{ duration: 0.5 }}
                            viewport={{ once: true }}
                        >
                            <img
                                src={image2}
                                style={{
                                    marginTop: "20px",
                                    maxWidth: "100%",
                                    minHeight: "auto"
                                }}
                            />
                        </motion.div>
                    </Grid>
                    <Grid
                        item
                        md={6}
                        sm={11}
                        xs={11}
                        sx={{ ml: { xs: 0, md: 2 }, mt: { xs: 3, md: 0 }, mb: 5 }}
                    >
                        <motion.div
                            initial={{ opacity: 0 }}
                            whileInView={{ opacity: 1 }}
                            transition={{ duration: 0.6, delay: 0.2 }} // Delayed reveal for emphasis
                        >
                            <Divider sx={{ color: "#FF7600" }} role="presentation">
                                <Typography
                                    sx={{
                                        fontSize: 26,
                                        fontWeight: 600,
                                        padding: "20px",
                                        color: "#32325d",
                                    }}
                                >
                                    {t("forBusiness.title2")}
                                </Typography>
                            </Divider>
                        </motion.div>

                        <motion.div
                            initial="hidden"
                            whileInView="visible"
                            transition={{ staggerChildren: 0.2 }} // Staggered effect for list items
                            viewport={{ once: true }}
                        >
                            <List sx={{ width: "100%", maxWidth: 360, padding: "10px" }}>
                                {["uList4", "uList5", "uList6"].map((key, index) => (
                                    <motion.div
                                        key={index}
                                        initial={{ opacity: 0, y: 20 }}
                                        whileInView={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4, delay: index * 0.2 }}
                                        viewport={{ once: true }}
                                        whileHover={{ scale: 1.05 }}
                                    >
                                        <ListItem sx={{ borderLeft: "4px solid #4a90e2", mb: 1 }}>
                                            <ListItemText
                                                primaryTypographyProps={{
                                                    fontSize: "16px",
                                                    fontWeight: "bold",
                                                    color: "#32325d",
                                                }}
                                                primary={t(`forBusiness.${key}`)}
                                            />
                                        </ListItem>
                                    </motion.div>
                                ))}
                            </List>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 30 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.5, delay: 0.8 }} // Slight delay for smooth flow
                            viewport={{ once: true }}
                        >
                            <Typography
                                sx={{
                                    fontSize: 16,
                                    color: "#32325d",
                                    padding: "20px",
                                }}
                            >
                                {t("forBusiness.description2")}
                            </Typography>
                        </motion.div>
                    </Grid>
                </Grid>

            </Grid >
        </>
    )
}

export default ForBusiness
